"use strict";
exports.__esModule = true;
exports.OPTIMIZATION_TYPE = void 0;
var OPTIMIZATION_TYPE;
(function (OPTIMIZATION_TYPE) {
    OPTIMIZATION_TYPE[OPTIMIZATION_TYPE["ANONYMOUS"] = 1] = "ANONYMOUS";
    OPTIMIZATION_TYPE[OPTIMIZATION_TYPE["NAMED_VRP"] = 2] = "NAMED_VRP";
    OPTIMIZATION_TYPE[OPTIMIZATION_TYPE["NAMED_PDP"] = 3] = "NAMED_PDP";
    OPTIMIZATION_TYPE[OPTIMIZATION_TYPE["ROUTE_BASED"] = 4] = "ROUTE_BASED";
    OPTIMIZATION_TYPE[OPTIMIZATION_TYPE["CREW_BASED"] = 5] = "CREW_BASED";
})(OPTIMIZATION_TYPE = exports.OPTIMIZATION_TYPE || (exports.OPTIMIZATION_TYPE = {}));
//# sourceMappingURL=optimization_type.js.map